import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import { Chip, Divider, FormControl, InputLabel, OutlinedInput, Stack } from "@mui/material";
import { FC, forwardRef, useMemo } from "react";
import { MetadataInputProps } from "../metadata-input-index";
import { SynopsisMetadataInfos } from "../../../Core/Api/Types/synopsis-metadata-infos";
import React from "react";
import { useTranslation } from "react-i18next";

type SynopsisMetadataInfosIndexed = {
  index: number;
  data: SynopsisMetadataInfos;
};

const MetadataInputSynopses = forwardRef<any, MetadataInputProps>((props, ref) => {
  const { t } = useTranslation();
  const { onChange, data, value, cultureId, epNb } = props;

  const getLocalizedValues = (): SynopsisMetadataInfosIndexed[] => {
    let array: SynopsisMetadataInfosIndexed[] = [];

    if (value) {
      if (!cultureId) return (value as SynopsisMetadataInfos[]).map((data, index) => ({ index: index, data: data }));

      for (let i = 0; i < (value as SynopsisMetadataInfos[]).length; ++i) {
        if (
          value[i].languageLocalizedCultureId &&
          value[i].languageLocalizedCultureId === cultureId &&
          value[i].epNb === epNb
        )
          array.push({ index: i, data: value[i] });
      }
    }

    return array;
  };

  const localized = useMemo((): SynopsisMetadataInfosIndexed[] => {
    return getLocalizedValues();
  }, [value, cultureId, epNb]);

  return (
    <>
      {localized.map((val, index) => (
        <React.Fragment key={index}>
          <FormControl sx={{ mb: 2, mt: index > 0 ? 2 : 0 }}>
            <InputLabel shrink htmlFor="short-text">
              {t("field:label.shortText")}
            </InputLabel>
            <OutlinedInput
              id="short-text"
              multiline
              rows={2}
              value={val.data.textShort || ""}
              onChange={(e) =>
                onChange({ ...val.data, textShort: e.currentTarget.value, epNb: epNb }, data.id, val.index)
              }
            />
          </FormControl>
          <Stack direction="row" alignItems="center" spacing={1}>
            <ChipsMaxLength text={val.data.textShort} />
          </Stack>
          <Divider sx={{ mt: 2, mb: 2 }} />
          <FormControl sx={{ mb: 2 }}>
            <InputLabel shrink htmlFor="long-text">
              {t("common:longText")}
            </InputLabel>
            <OutlinedInput
              id="long-text"
              multiline
              rows={6}
              value={val.data.text || ""}
              onChange={(e) =>
                onChange(
                  { ...val.data, text: e.currentTarget.value, epNb: epNb },
                  data.id,
                  val.index >= 0 ? val.index : value.length
                )
              }
            />
          </FormControl>
          <Stack direction="row" alignItems="center" spacing={1}>
            <ChipsMaxLength text={val.data.text} />
          </Stack>
        </React.Fragment>
      ))}
    </>
  );
});

export default MetadataInputSynopses;

type ChipMaxLengthProps = {
  text: string | null;
};
const ChipsMaxLength: FC<ChipMaxLengthProps> = (props) => {
  const platforms = [
    {
      name: "Amazon",
      synLongMax: 2000,
      synShortMax: 400,
      img: "amazon.png",
    },
    {
      name: "Apple",
      synLongMax: 4000,
      synShortMax: 400,
      img: "apple.png",
    },
    {
      name: "Google",
      synLongMax: 5000,
      synShortMax: 400,
      img: "googleplay.png",
    },
    {
      name: "Microsoft",
      synLongMax: 4000,
      synShortMax: 190,
      img: "microsoft.png",
    },
    {
      name: "Sony",
      synLongMax: 1000,
      synShortMax: 256,
      img: "sony.png",
    },
    {
      name: "Vudu",
      synLongMax: 500,
      synShortMax: 400,
      img: "vudu.png",
    },
  ];

  return (
    <>
      {platforms.map((ref, index) => (
        <Chip
          label={`${ref.name} ${props.text ? props.text?.length : 0}/${ref.synLongMax}`}
          key={index}
          icon={<CategoryOutlinedIcon />}
          color={ref.synLongMax - (props.text ? props.text?.length : 0) <= 0 ? "warning" : "default"}
        />
      ))}
    </>
  );
};
